angular.module("footerInstant.components", [])
    .component("footerInstant", {
        templateUrl: "ng/components/footerInstant/footerInstant.view.html",
        bindings: {
            nextStepVisible: '<',
            backStepVisible: '<',
            pauseVisible: '<',
            nextStepEnabled: '<',
            backStepEnabled: '<',
            pauseEnabled: '<',
            titleNextStep: '<',
            titleBackStep: '<',
            navigationBack: '&?',
            navigationNext: '&?',
            titleNext: '@',
            titleBack: '@',
            enableLoaderBackPage: '<',
            enableLoaderNextPage: '<'
            // navigationPause: '&?'

        },
        controllerAs: "footerInstantCtrl",
        controller: FooterInstantController
    })
    function FooterInstantController ($modalService) {

            var self = this;
            self.$modalService = $modalService
            self.$onInit = function () {

                self.backStepEnabled = self.backStepEnabled;
                self.nextStepEnabled = self.nextStepEnabled;
                self.nextStepVisible = self.nextStepVisible;
                self.backStepVisible = self.backStepVisible;
            }

            self.$onChanges = function (changes) {
                console.log('changes');
                self.navigator.loading.next = self.enableLoaderNextPage;
                self.navigator.loading.back = self.enableLoaderBackPage;
            }

            self.navigator = {
                loading: {
                    next: false,
                    back: false,
                    pause: false
                },
                somethingLoading: function () {
                    var some = false;
                    Object.keys(this.loading)
                        .forEach(function (value) {
                            if (self.navigator.loading[value] == true) {
                                some = true;
                            }
                        })
                    return some;
                },
                nextStep: function () {
                    this.loading.next = true;
                    self.navigationNext();
                    this.loading.next = false;

                },
                backStep: function () {
                    this.loading.back = true;
                    self.navigationBack();
                    this.loading.back = false;

                },
            }




        }
    